import CodeArea from './CodeArea';
export default CodeArea;
